<kodit-dugovanje-notification
  *ngIf="showDugovanjeNotification"
></kodit-dugovanje-notification>

<div class="p-mb-3 p-fluid"
     style="margin-top: -18px">
  <p-messages severity="success">
    <ng-template pTemplate>
      <div class="p-d-flex p-jc-between" style="width: 100%">
        <div class="p-d-flex p-flex-column p-jc-center gap-6">
          <div>
            Da li je vaša firma spremna za inspekcijski nadzor iz oblasti
            bezbednosti i zdravlja na radu?
          </div>
          <div>
            Pozovite nas na <span class="p-text-bold">060/55-33-469</span> ili
            <span class="p-text-bold">060/66-99-384</span> i zatražite ponudu za
            kompletnu BZR uslugu.
          </div>
        </div>
        <div class="p-d-flex p-ai-center p-jc-center">
          <span
            class="p-message-icon pi pi-question-circle"
            style="font-size: 2.5rem"
          ></span>
        </div>
      </div>
    </ng-template>
  </p-messages>
<!--  <p-messages severity="warn">-->
<!--    <ng-template pTemplate>-->
<!--      <div class="p-d-flex p-jc-between" style="width: 100%">-->
<!--        <div class="p-d-flex p-flex-column p-jc-center gap-6">-->
<!--          <div>-->
<!--            Poštovani korisniče,-->
<!--            <br/>-->
<!--            Obaveštavamo Vas da će u subotu, 03.10, u periodu od 22:00 do 22:30 časa, aplikacija eKompanija biti privremeno nedostupna zbog planiranih radova na održavanju sistema.-->
<!--            <br/>-->
<!--            Hvala na razumevanju.-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="p-d-flex p-ai-center p-jc-center">-->
<!--          <span-->
<!--            class="p-message-icon pi pi-exclamation-circle"-->
<!--            style="font-size: 2.5rem"-->
<!--          ></span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </ng-template>-->
<!--  </p-messages>-->
</div>